import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, FormControlLabel, FormLabel, RadioGroup, Radio, Paper } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import ImagePicker from "src/components/common/ImagePicker";
import NavBack from "src/components/common/NavBack";
import MyEditor from "src/components/editor/MyEditor";
import Uploader from "src/components/uploader/Uploader";

export default function ArticleDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const item = useLocation().state || {};

  const [detail, setDetail] = useState(item.detail);

  const [form, setForm] = useState({
    html: item.html || "",
    title: item.title || "",
    subtitle: item.subtitle || "",
    cover: item.cover || "",
    isShow: item.isShow != undefined ? (item.isShow ? 1 : 0) : 1,
  });

 
  useEffect(() => {
    if (!id) return;
    return;
    axios
      .get(`/article/one/${id}`)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setForm({
            ...form,
            ...data,
          });
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }, []);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSubmit() {
    const formData = {
      ...form,
      detail,
    };

    if (id) {
      formData.id = id;
    }

    axios
      .post(id ? "/article/edit" : "/article/add", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          navigate(-1, { replace: true });
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加文章出错: ", err);
      });
  }


  return (
    <Page title={`${id ? "编辑" : "添加"}文章 | ${COMP_NAME}`}>
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title={`${id ? "编辑" : "添加"}文章`} />
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <FormItem title="标题" required>
            <TextField fullWidth placeholder="请输入标题" autoComplete="off" id="title" value={form.title} size="small" onChange={(e) => handleIptChange("title", e.target.value)} />
          </FormItem>

          <FormItem title="封面">
            <Uploader images={form.cover} onUploaded={(v) => handleIptChange("cover", v)} />
          </FormItem>

          <FormItem title="状态" required>
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
              <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
              <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            </RadioGroup>
          </FormItem>

          {/* <FormItem title="摘要">
            <TextField fullWidth placeholder="请输入摘要，不填写可能选取正文前20个文字" autoComplete="off" id="subtitle" value={form.subtitle} size="small" onChange={(e) => handleIptChange("subtitle", e.target.value)} />
          </FormItem> */}

          <FormItem title="内容" required>
            <Paper variant="outlined" sx={{ paddingX: 2, paddingY: 1, flex: 1, minHeight: 220 }}>
              <MyEditor
                html={form.detail}
                onChange={(val) => {
                  setDetail(val);
                }}
              />
            </Paper>
          </FormItem>

          <FormItem>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              确认{id ? "保存" : "添加"}
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
